<template>
<v-container fluid>
  <v-row dense>
    <v-col cols="12">
      <v-card width="auto" title>
        <v-card-text>
          <fusioncharts v-if="showChart"
            :type="type"
            :width="width"
            :height="height"
            dataFormat="json"
            :dataSource="dataSource"
            :events="eventsChart">
            FusionCharts will render here...
          </fusioncharts>
          <v-alert v-if="showChartMessage" border="top" color="primary" prominent type="info">
            <span style="margin: 0 auto" class="title white--text text-center"> NO HAY INFORMACION PARA MOSTRAR </span>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  props: ['object', 'data'],
  data: (m) => ({
    width: '100%',
    height: '500',
    type: 'pie2d',
    dataFormat: 'json',
    showChart: false,
    showChartMessage: true,
    dataSource: {
      chart: {
        caption: 'titulo',
        subCaption: 'sub-titulo',
        numberPrefix: '$',
        showPercentInTooltip: '0',
        decimals: '1',
        useDataPlotColorForLabels: '1',
        theme: 'fusion'
      },
      data: [{ label: 'titulo', value: 0 }]
    },
    eventsChart: {
      dataPlotClick: m.EventClickAction,
      beforeRender: m.RenderShowData
    },
    chartUpdate: null
  }),
  components: {},
  mounted () {
    this.dataSource.chart = this.object
  },
  computed: {},
  methods: {
    EventClickAction (event) {},
    RenderShowData (evt, args) {
      this.chartUpdate = evt.sender
      if (this.data && this.data.length > 0) {
        var grafData = this.chartUpdate.getJSONData()
        grafData.data = this.data
        this.chartUpdate.setJSONData(grafData)
      }
    }
  },
  watch: {
    data (val) {
      if (val) {
        if (val.length <= 0) {
          this.showChartMessage = true
          this.showChart = false
          return
        }
        this.showChartMessage = false
        this.showChart = true

        var grafData = this.chartUpdate.getJSONData()
        grafData.data = val
        this.chartUpdate.setJSONData(grafData)
      }
    }
  }
}
</script>

<style>

</style>
